var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.32293C13.8112 4.97036 14 4.50723 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 4.50723 10.1888 4.97036 10.5 5.32293L4.15838 18.0062C4.10613 18.0021 4.05331 18 4 18C2.89543 18 2 18.8954 2 20C2 21.1046 2.89543 22 4 22C4.83934 22 5.55793 21.483 5.85462 20.75H18.1454C18.4421 21.483 19.1607 22 20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C19.9467 18 19.8939 18.0021 19.8416 18.0062L13.5 5.32293ZM11.8416 5.99382C11.8939 5.99791 11.9467 6 12 6C12.0533 6 12.1061 5.99791 12.1584 5.99382L18.5 18.6771C18.3515 18.8453 18.2309 19.0387 18.1454 19.25H5.85462C5.76908 19.0387 5.64846 18.8453 5.49999 18.6771L11.8416 5.99382Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkAlt);
export default __webpack_public_path__ + "static/media/network-alt.c31b916c046066f548d19a5d364aeb77.svg";
export { ForwardRef as ReactComponent };